import { z } from "zod/v4";
/** プラス小数金額のみ */
export const PositiveFractionalAmountSchema = z
    .number()
    .nonnegative()
    .refine((val) => Number.isFinite(val) &&
    Math.abs(Math.round(val * 100) - val * 100) < 1e-8, {
    error: "小数点第2位までの正の数を入力してください",
})
    .brand()
    .brand();
export const PositiveFractionalAmount = {
    schema: PositiveFractionalAmountSchema,
    of(args) {
        return PositiveFractionalAmount.schema.parse(args);
    },
};
//# sourceMappingURL=fractionalAmount.js.map